module.exports = __webpack_public_path__ + "static/media/kilometer-sm.e12d25c5.svg";